module.exports = __webpack_public_path__ + "img/dynamic-7.fbf6b91e.png";